<template>
  <portal>
      <div class="mb-8 d-flex align-center">
          <v-icon color="primary" size="30">mdi-currency-usd</v-icon>
          <h1 class="headline ml-4 font-weight-bold grey--text--darken-2 text-uppercase">Net Worth Summary</h1>
      </div>
      <net-worth-summary
          :date="today"
          :net-worth-summary-data="totals"
          :properties="householdProperties(this.householdId)"
          :life-insurances="householdLifeInsurances(this.householdId)"
          :assets="householdAssets(this.householdId)"
          :liabilities="householdLiabilities(this.householdId)">
      </net-worth-summary>
  </portal>
</template>

<script>
import Portal from "@/components/Portal";
import NetWorthSummary from "@/components/net-worth-summary/NetWorthSummary";
import {mapState, mapActions, mapGetters} from "vuex";
import moment from "moment";

export default {
    name: "NetWorth",
    data() {
        return {
            reportLoading: false,
            today: moment().format('MMMM Do YYYY'),
        }
    },
    components: {
      NetWorthSummary,
      Portal,
    },
    inject: ['householdId'],
    computed: {
        ...mapState('company', [
            'company'
        ]),
        ...mapState('netWorthSummary', ['totals']),
        ...mapGetters('property', [
            'householdProperties',
            'getHouseholdPropertiesWithBeneficiaries',
            'properties'
        ]),
        ...mapGetters('lifeInsurance', [
            'getHouseholdLifeInsurancesWithBeneficiaries',
            'householdLifeInsurances'
        ]),
        ...mapGetters('asset', [
            'getHouseholdAssetsWithBeneficiaries',
            'householdAssets'
        ]),
        ...mapGetters('liability', ['householdLiabilities']),
    },
    mounted() {
        this.loadProperties({householdId: this.householdId});
        this.loadLifeInsurances({householdId: this.householdId});
        this.loadLiabilities({householdId: this.householdId});
        this.summary({householdId: this.householdId});
    },

    methods: {
        ...mapActions('property', ['loadProperties']),
        ...mapActions('lifeInsurance', ['loadLifeInsurances']),
        ...mapActions('liability', ['loadLiabilities']),
        ...mapActions('netWorthSummary', ['summary'])
    }
  }
</script>
